module.exports = __webpack_public_path__ + "static/media/weather.1a2b8b30.png";